export var sessionStorage = true && window.sessionStorage ? window.sessionStorage : null;